<template>
  <div :class="{ 'disabled-node': disabled }">
    <gradient-range :color="'#1976d2'" :cols="11" v-model="form.winrs.value" />
    <p class="reference">
      Referência: Yosipovitch, G., et al. "Peak Pruritus Numerical Rating Scale: psychometric validation and
      responder definition for assessing itch in moderate‐to‐severe atopic dermatitis." British Journal of
      Dermatology 181.4 (2019): 761-769.
    </p>
  </div>
</template>
<script>
import GradientRange from '@/components/GradientRange.vue'
import { createNamespacedHelpers } from 'vuex'

const {
  mapMutations: newAttendanceFormMutations,
  mapActions: newAttendanceFormActions,
  mapGetters: newAttendanceFormGetters,
} = createNamespacedHelpers('newAttendanceForm')

export default {
  name: 'WiNrsFormNode',
  components: { GradientRange },
  created() {
    const baseValue = {
      winrs: {
        value: null,
      },
    }
    this.form = this.extraAnswers['wi-nrs'] ?? baseValue
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    .../** @type {{parameters: Computed<ObjectLiteral>, extraAnswers: Computed<ObjectLiteral>}} */ (
      newAttendanceFormGetters(['parameters', 'extraAnswers'])
    ),
  },
  methods: {
    ...newAttendanceFormMutations(['updateExtraAnswer']),
    ...newAttendanceFormActions(['getParameter', 'getExtraAnswer']),
  },
  data() {
    return {
      form: {
        winrs: {
          value: null,
        },
      },
    }
  },
  watch: {
    form: {
      handler(value) {
        this.updateExtraAnswer({ name: 'wi-nrs', value })
      },
      deep: true,
    },
  },
}
</script>
<style scoped>
.reference {
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  margin-top: 120px;
}
</style>
